module.exports = __webpack_public_path__ + "static/img/product3-4.7d02a8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product3-4.jpg
// module id = H2cy
// module chunks = 0